import { MutationTree } from 'vuex';
import { VideoStore } from './type';

const mutations: MutationTree<VideoStore> = {
  setEndState(state, flag: boolean) {
    state.isEnd = flag;
  },
  clear(state) {
    state.isEnd = false;
  }
};

export default mutations;
